<template>
  <div>
    <div class="card-body print-form" :id="receiptId">
      <b-row class="">
        <b-col cols="12">
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span>
                  <h1
                    class="mb-0 tx-rubik text-center company_name text-uppercase shop-header"
                  >
                    <!-- <img class="logo" height="40px" width="40px" :src="GetOrganization.image" /> -->
                    Gnanams Hotel
                  </h1>
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 mb-0 tx-rubik tx-12 text-center">
                  299, 301 Clock Tower Rd, Jaffna
                </h6>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <h6 class="mt-0 tx-12 tx-rubik text-center">0212 220 630</h6>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="font-weight-bold">
          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Order Number
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="font-weight: bold">
                  {{ Order.order_number }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Customer
                </span>
              </td>
              <td
                class="unit-price"
                style="color: black; text-align: right"
                v-if="Order && Order.guest"
              >
                <span class="tx-rubik" style="color: black">
                  {{ Order.guest.name }}
                </span>
              </td>
            </tr>
            <tr v-if="Order && Order.note && String(Order.note).indexOf('Website pickup') === 0">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Source
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  Website
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Waiter
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span
                  class="tx-rubik"
                  style="color: black"
                  v-if="Order.waiter && Order.waiter.name"
                >
                  {{ Order.waiter.name }}
                </span>
              </td>
            </tr>
            <tr v-if="Order.room && Order.room.name != null">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Room
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ Order.room.name }}
                </span>
              </td>
            </tr>

            <tr v-if="Order.table && Order.table.name != null">
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Table
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ Order.table.name }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Date
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black">
                  {{ new Date() | formatDateTime }}
                </span>
              </td>
            </tr>

            <tr>
              <td class="description" style="color: black; text-align: left">
                <span class="tx-rubik" style="color: black; text-align: left">
                  Biller
                </span>
              </td>
              <td
                class="unit-price"
                style="color: black; text-align: right"
                v-if="Order.createdby"
              >
                <span class="tx-rubik" style="color: black">
                  {{ Order.createdby.first_name }}
                </span>
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
      <hr style="b margin-bottom: 10px" />

      <b-row>
        <b-col>
          <table style="width: 400px; margin: 0px 5px">
            <thead>
              <tr style="border-bottom: solid 2px">
                <th
                  class="description"
                  style="color: black; text-align: left; width: 200px"
                >
                  Item
                </th>
                <th
                  class="unit-price unit-price-text"
                  style="color: black; text-align: right; width: 100px"
                >
                  Price
                </th>
                <th style="color: black; text-align: right; width: 50px">
                  Qty
                </th>

                <th
                  class="amount unit-price-text"
                  style="color: black; text-align: right; width: 100px"
                >
                  Total
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, index) in Order.items"
                :key="index"
                style="border-top: dashed 1px"
              >
                <td
                  v-if="product.dish"
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 110px;
                  "
                >
                  <h6 class="text-left padding-top-0px" style="font-size: 14px">
                    {{ product.dish.name }}<span v-if="product.unit">- {{ product.unit.name }}</span>
                  </h6>

                  <table v-if="product.ingredients && product.ingredients.length" class="width-100perc">
                    <tbody>
                      <tr
                        v-for="(item, index) in product.ingredients"
                        :key="index"
                        class="secondry-color text-left"
                      >
                        <td width="20px" class="text-right">+</td>
                        <td>Add {{ item.name }} ({{ item.amount }})</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td
                  class="unit-price"
                  style="color: black; text-align: right; width: 80px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ product.amount }}
                  </span>
                </td>
                <td
                  v-if="product.product"
                  class="description"
                  style="
                    color: black;
                    padding-top: 5px;
                    padding-bottom: 5px;
                    width: 110px;
                  "
                >
                  <h6 class="text-left padding-top-0px">
                    {{ product.product.name }}
                  </h6>
                </td>
                <td
                  class="quantity"
                  style="color: black; text-align: right; width: 30px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik"
                    v-if="product.adjust_quantity <= 0"
                  >
                    {{ product.quantity }}
                  </span>
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik"
                    v-if="product.adjust_quantity > 0"
                  >
                    {{ product.adjust_quantity }}g
                  </span>
                </td>

                <td
                  class="amount"
                  style="color: black; text-align: right; width: 100px"
                >
                  <span
                    style="color: black; text-align: right"
                    class="tx-rubik unit-price-text"
                  >
                    {{ product.quantity * product.amount }}.00
                  </span>
                </td>
              </tr>
            </tbody>
          </table>

          <table style="width: 400px; margin: 0px 5px">
            <tr>
              <td
                colspan="1"
                class="description"
                style="color: black; text-align: left"
              >
                <hr style="border-top: solid 1px; margin: 1px" />

                <span
                  v-if="Order.items"
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  No of items - {{ Order.items.length }}
                </span>
              </td>
              <td
                colspan="1"
                class="description"
                style="color: black; text-align: right; white-space: nowrap"
              >
                <hr style="border-top: solid 1px; margin: 1px" />

                <span
                  v-if="Order.items"
                  class="tx-rubik"
                  style="color: black; text-align: right; font-weight: bold"
                >
                  Payment Type - {{ paymentLabel }}
                </span>
              </td>
            </tr>
            <tr>
              <td
                class="description"
                style="color: black; text-align: left; padding-top: 10px"
              >
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Total
                </span>
              </td>
              <td
                class="unit-price"
                style="color: black; text-align: right; padding-top: 10px"
              >
                <span
                  class="tx-rubik"
                  style="color: black; font-weight: bold"
                  v-if="Order.ingredient_amount > 0"
                >
                  {{ Order.amount + Order.ingredient_amount }}.00
                </span>
                <span
                  class="tx-rubik"
                  style="color: black; font-weight: bold"
                  v-else
                >
                  {{ Order.amount }}.00
                </span>
              </td>
            </tr>
            <!-- {{Order.service_charge}} -->
            <tr v-if="Order.service_charge > 0">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  {{ Order.order_type === 'take_away' ? 'Packing' : 'Service Charge' }}
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.service_charge }}
                </span>
              </td>
            </tr>
            <tr v-if="Order.tax > 0">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Tax
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.tax }}
                </span>
              </td>
            </tr>
            <tr v-if="Order.descount > 0">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Discount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.descount }}
                </span>
              </td>
            </tr>
            <tr>
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Net Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.net_amount }}.00
                </span>
              </td>
            </tr>
            <tr v-if="EventTablePartial">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  last Paid ToatalAmount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.paid_amount }}
                </span>
              </td>
            </tr>

            <tr v-if="showReceivedAmount">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Received Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ paymentAmount > 0 ? paymentAmount : Order.paid_amount }}
                </span>
              </td>
            </tr>
            <tr v-if="EventTable">
              <td class="description" style="color: black; text-align: left">
                <span
                  class="tx-rubik"
                  style="color: black; text-align: left; font-weight: bold"
                >
                  Received Amount
                </span>
              </td>
              <td class="unit-price" style="color: black; text-align: right">
                <span class="tx-rubik" style="color: black; font-weight: bold">
                  {{ Order.net_amount }}
                </span>
              </td>
            </tr>

            <tr style="margin-top: 10px">
              <td colspan="2" style="margin-top: 20px">
                <h4 style="text-align: center; margin-top: 20px; color: black">
                  <!-- நன்றி மீண்டும் வருக ! -->
                  Thank You Come Again!
                </h4>
              </td>
            </tr>

            <tr style="margin-top: 30px">
              <td
                colspan="2"
                style="
                  font-size: 12px;
                  padding-top: 5px;
                  color: black;
                  text-align: center;
                "
              >
                Powered by SpeedCodeLabs (Pvt) Ltd | 0212 211 599
              </td>
            </tr>
          </table>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintBill',
  props: {
    TicketNumber: {
      type: String,
      default: '',
    },
    Order: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  components: {},
  computed: {
    receiptId() {
      const id = this.Order && this.Order.id ? this.Order.id : this._uid;
      return 'customer-receipt-' + id;
    },
    paymentLabel() {
      const payments = this.Order && this.Order.payment;
      if (payments && payments[0] && payments[0].payment_type) {
        return payments[0].payment_type;
      }
      return this.Order && this.Order.order_type === 'take_away'
        ? 'Pay at pickup'
        : '';
    },
    showReceivedAmount() {
      const order = this.Order || {};
      const roomName = order.room && order.room.name;
      const tableName = order.table && order.table.name;
      return roomName != null || (tableName != null && !this.EventTable);
    },
  },
  methods: {
    print() {
      const element = this.$el && this.$el.querySelector('.print-form');
      if (!element) return;
      let frame = document.getElementById('customer-bill-print-frame');
      if (!frame) {
        frame = document.createElement('iframe');
        frame.id = 'customer-bill-print-frame';
        frame.setAttribute(
          'style',
          'position:fixed;right:0;bottom:0;width:0;height:0;border:0;',
        );
        document.body.appendChild(frame);
      }
      const doc = frame.contentWindow.document;
      doc.open();
      doc.write(
        '<!DOCTYPE html><html><head><title>Customer bill</title>' +
          '<style>body{font-family:Arial,sans-serif;color:#000;margin:16px;}table{width:100%;border-collapse:collapse;}</style>' +
          '</head><body>' +
          element.innerHTML +
          '</body></html>',
      );
      doc.close();
      frame.contentWindow.focus();
      frame.contentWindow.print();
    },
  },
};
</script>
<style>
.row {
  margin-right: -15px;
  margin-left: -15px;
}
.width-100perc {
  width: 100% !important;
}
.modal-body input[type='text'] {
  margin-bottom: 5px;
}
input[type='text'],
input[type='password'],
textarea,
input[type='tel'],
input[type='email'],
input[type='number'] {
  padding: 7px;
  margin-top: 10px;
  border-radius: 3px;
  /* border-bottom: #e5e5e5 2px solid; */
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}

element.style {
}

.vh-100 {
  height: 100vh;
}
div {
  text-align: left;
}
input {
  width: auto;
  border: auto;
}
.row {
  margin: 0px;
}
.btnComplete {
  background: var(--brand-primary);
  padding: 15px 25px;
  width: 80%;
  margin: 20px auto !important;
  color: white !important;
  font-size: 15px !important;
  border: none;
  outline: none;
  border-radius: 14px;
}

.row_style {
  background: #f3f3f3;
  padding: 12px;
  margin: 0 80px;
  border-radius: 16px;
  margin: 0 80px 9px;
}
.payment-type {
  height: 42px;
  padding: 0 13px;
}
.description,
.description {
  width: 80px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.print-form .description,
.print-form .unit-price,
.print-form .quantity,
.print-form .amount {
  word-break: normal;
}

.unit-price,
.unit-price {
  width: 90px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.unit-price-text {
  text-align: right;
}

.quantity,
.quantity {
  width: 40px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.discount,
.discount {
  width: 90px;
  word-break: break-all;
  padding: 0px 10px;
}

.amount,
.amount {
  width: 100px;
  word-break: break-all;
  /* padding: 0px 10px; */
}

.centered {
  text-align: center;
  align-content: center;
}

.ticket {
  width: 155px;
  max-width: 155px;
}

img {
  max-width: inherit;
  width: inherit;
}
#receiptData {
  width: 100%;
  background: white;
}
</style>
